// extracted by mini-css-extract-plugin
export var backdropBlur = "_ep-0";
export var contentCard = "_ep-5";
export var frame = "_ep-2";
export var image = "_ep-4";
export var imagePane = "_ep-3";
export var modal = "_ep-1";